import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent implements OnInit {
  private _imageUrl: any;

  @Input() set imageUrl(value: any) {
    this._imageUrl = value;
  }

  get imageUrl() {
    return this._imageUrl;
  }
  @Input() surname: string;
  @Input() name: string;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {}

  getSanitizedUrl() {
    return this.sanitizer.bypassSecurityTrustUrl(this._imageUrl);
  }

  hasPicture() {
    return this.imageUrl != null && this.imageUrl != '';
  }

  getInitiales() {
    return '';
  }
}
